"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
var _Card = _interopRequireDefault(require("../../../components/Card"));
var _formMixin = _interopRequireDefault(require("../../formMixin"));
var _draggableEffect = _interopRequireDefault(require("../../../components/js/draggableEffect"));
var _enum = require("../../../components/js/enum");
var _common = require("../../../components/js/common");
var _utils = require("@/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CarouselForm',
  mixins: [_formMixin.default, _draggableEffect.default],
  components: {
    linkaddressVue: _linkaddress.default,
    Card: _Card.default
  },
  data: function data() {
    return {
      showTypeEnum: _enum.showTypeEnum,
      initData: {
        url: '',
        pic: ''
      },
      form: {
        showType: 4,
        activity: [],
        activePadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        }
      },
      showActive: true,
      itemIndex: null
    };
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.activePadding)) {
          this.$set(this.form, 'activePadding', {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    swapElement: _common.swapElement,
    linkUrl: function linkUrl(url) {
      this.form.activity[this.itemIndex].url = url;
    },
    openLink: function openLink(index) {
      this.itemIndex = index;
      this.$refs.linkaddressVueRef.dialogVisible = true;
    },
    upload: function upload(index) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form.activity[index], 'pic', data[0].sattDir);
      });
    },
    changeShowCate: function changeShowCate() {
      var _this$form2,
        _this$form3,
        _this2 = this;
      this.showActive = false;
      this.form['activity'] = [];
      if (!((_this$form2 = this.form) !== null && _this$form2 !== void 0 && _this$form2.imgType)) return;
      var activity = [];
      var arrNumMap = {
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 3,
        6: 4
      };
      var length = arrNumMap[(_this$form3 = this.form) === null || _this$form3 === void 0 ? void 0 : _this$form3.imgType];
      if (!length) return;
      for (var i = 0; i < length; i++) {
        activity.push({
          url: '',
          pic: ''
        });
      }
      ;
      this.$set(this.form, 'activity', activity);
      setTimeout(function () {
        _this2.showActive = true;
      }, 100);
    },
    handleDragenter: function handleDragenter(index) {
      this.dragging = index;
      var currentIndex = index;
      var dragStartIndex = this.dragStartIndex;
      if (currentIndex !== dragStartIndex) {
        this.form.activity = this.swapElement(this.form.activity, currentIndex, dragStartIndex);
        this.dragStartIndex = currentIndex;
      }
    }
  }
};